import { render } from "./TrListPopPage.vue?vue&type=template&id=5b8208cc&scoped=true"
import script from "./TrListPopPage.vue?vue&type=script&lang=js"
export * from "./TrListPopPage.vue?vue&type=script&lang=js"

import "./TrListPopPage.vue?vue&type=style&index=0&id=5b8208cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8208cc"]])

export default __exports__